import { render, staticRenderFns } from "./NewResponse.vue?vue&type=template&id=5b38c08a&scoped=true&"
import script from "./NewResponse.vue?vue&type=script&lang=js&"
export * from "./NewResponse.vue?vue&type=script&lang=js&"
import style0 from "./NewResponse.vue?vue&type=style&index=0&id=5b38c08a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b38c08a",
  null
  
)

export default component.exports
import {QInput,QToggle,QBtn,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QToggle,QBtn,QIcon})
